export default "__VITE_ASSET__ICe8UiHU__"